import styles from '@/styles/Info.module.scss'
import BaseLayout from '@/layout/BaseLayout/BaseLayout'
import Head from 'next/head'
import React from 'react'
import { GetStaticProps } from 'next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { getPageTitle } from '@/utils/helpers'
import { useTranslation } from 'next-i18next'
import Raw from '@/components/common/Raw/Raw'
import { Roboto } from "next/font/google"
import Image from 'next/image'
import heroShippingImage from '@/assets/images/hero-shipping.png'
import classNames from 'classnames'
import ContactForm from '@/components/common/ContactForm/ContactForm'

const roboto = Roboto({
  subsets: ['latin'],
  weight: ['300'],
})

type Props = {}

const Shipping = (props: Props) => {
  const { t } = useTranslation('shipping')

  return (
    <BaseLayout>
      <Head>
        <title>{getPageTitle(t('title'))}</title>
      </Head>
      <Image
        src={heroShippingImage}
        alt="Hero"
        style={{
          width: '100%',
          height: 'auto',
        }}
      />
      <main className={classNames(styles.info, styles.split)}>
        <div>
          <h1>{t('title')}</h1>
          <h3>{t('deliveryTime')}</h3>
          <p>
            {t('deliveryTimeText')}
          </p>
          <h3>{t('shippingAndReturns')}</h3>
          <p>
            {t('shippingAndReturnsText')}
          </p>
          <h3>{t('returns')}</h3>
          <p>
            {t('retrunsText')}
          </p>
        </div>
        <div>
          <ContactForm />
        </div>
      </main>
    </BaseLayout>
  )
}

export default Shipping

export const getStaticProps: GetStaticProps<Props> = async ({
  locale,
}) => ({
  props: {
    ...(await serverSideTranslations(locale ?? 'en', [
      'common',
      'shipping',
      'footer',
    ])),
  },
})